import React, { useRef, useState, useEffect } from 'react';

import { Text } from 'react-konva';
import Konva from 'konva';
import type { KonvaEventObject } from 'konva/lib/Node';

import TextEditor from 'Components/CanvasEditor/components/elements/TextEditor';

import { CanvasElement, TextElement as TextElementType } from 'Components/CanvasEditor/types';

interface TextElementProps {
  element: TextElementType;
  onDragStart: (e: KonvaEventObject<DragEvent>) => void;
  onDragEnd: (e: KonvaEventObject<DragEvent>) => void;
  onElementChange: (props: Partial<CanvasElement>, id: string, saveToHistory?: boolean) => void;
}

export default function TextElement({
  element,
  onDragStart,
  onDragEnd,
  onElementChange,
}: TextElementProps) {
  const textRef = useRef<Konva.Text>(null);

  const [isEditing, setIsEditing] = useState(false);
  const [textValue, setTextValue] = useState(element.text);

  useEffect(() => {
    setTextValue(element.text);
  }, [element.text]);

  const handleDblClick = () => {
    setIsEditing(true);
  };

  const onClose = () => {
    setIsEditing(false);

    if (textValue !== element.text) {
      onElementChange({ text: textValue }, element.id, true);
    }
  };

  const onInput = (value: string) => {
    setTextValue(value);
  };

  const onTransform = (e: KonvaEventObject<Event>) => {
    const node = e.currentTarget;

    const scaleX = node.scaleX();
    // const scaleY = node.scaleY();

    const newWidth = node.width() * scaleX;
    // const newHeight = node.height() * scaleY;

    // const activeAnchor = transformerRef.current?.getActiveAnchor();
    // const horizontalAnchors = ['middle-left', 'middle-right'];
    //
    // const oldFontSize = node.attrs.fontSize;
    // let newFontSize = oldFontSize;
    // const anchor = activeAnchor;

    // const isCornerTransforming = !horizontalAnchors.includes(activeAnchor as string);
    // if (anchor?.includes('top') || anchor?.includes('bottom')) {
    //   const avgScale = (scaleX + scaleY) / 2;
    //   newFontSize = Math.floor(oldFontSize * avgScale);
    // }

    node.scaleX(1);
    node.scaleY(1);

    onElementChange(
      {
        x: node.x(),
        y: node.y(),
        width: newWidth,
        scaleX: 1,
        scaleY: 1,
      },
      element.id
    );

    // node.setAttrs({
    //   width: newWidth,
    //   scaleX: 1,
    // });
  };

  const onTransformEnd = (e: KonvaEventObject<Event>) => {
    const node = e.currentTarget;

    const scaleX = node.scaleX();
    const newWidth = node.width() * scaleX;

    node.scaleX(1);
    node.scaleY(1);

    onElementChange(
      {
        x: node.x(),
        y: node.y(),
        width: newWidth,
        scaleX: 1,
        scaleY: 1,
      },
      element.id,
      true
    );
  };

  return (
    <>
      {isEditing && (
        <TextEditor
          textNode={textRef.current as Konva.Text}
          onChange={onElementChange}
          onInput={onInput}
          onClose={onClose}
        />
      )}
      <Text
        ref={textRef}
        name="object"
        id={element.id}
        x={element.x}
        y={element.y}
        width={element.width}
        text={textValue}
        fontSize={element.fontSize}
        fontFamily={element.fontFamily}
        fontStyle={element.fontStyle}
        textDecoration={element.textDecoration}
        fill={element.fill}
        align={element.align}
        draggable={!isEditing && element.draggable}
        visible={element.visible && !isEditing}
        rotation={element.rotation}
        scaleX={element.scaleX}
        scaleY={element.scaleY}
        onDblClick={handleDblClick}
        onTransform={onTransform}
        onTransformEnd={onTransformEnd}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        perfectDrawEnabled
      />
    </>
  );
}
